class WishlistPage extends HTMLElement {
  static STORAGE_KEY = 'wishlist_product_ids';

  connectedCallback() {
    this.grid = this.querySelector('[data-wishlist-grid]');
    this.emptyMessage = this.querySelector('[data-wishlist-empty]');
    this.render();
  }

  getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(WishlistPage.STORAGE_KEY)) || [];
    } catch (error) {
      return [];
    }
  }

  setWishlist(list) {
    try {
      localStorage.setItem(WishlistPage.STORAGE_KEY, JSON.stringify(list));
    } catch (error) {
      // localStorage unavailable (private browsing, etc.) - fail silently
    }
    window.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { list } }));
  }

  removeFromWishlist(handle) {
    const updated = this.getWishlist().filter((item) => item !== handle);
    this.setWishlist(updated);
  }

  showEmptyState() {
    this.emptyMessage?.removeAttribute('hidden');
  }

  render() {
    const handles = this.getWishlist();

    if (!this.grid) return;
    this.grid.innerHTML = '';

    if (handles.length === 0) {
      this.showEmptyState();
      return;
    }
    this.emptyMessage?.setAttribute('hidden', '');

    Promise.all(
      handles.map((handle) =>
        fetch(`/products/${handle}?view=recently-viewed-card`)
          .then((response) => (response.ok ? response.text() : null))
          .then((html) => ({ handle, html }))
          .catch(() => ({ handle, html: null }))
      )
    )
      .then((results) => {
        const deadHandles = [];

        results.forEach(({ handle, html }) => {
          if (!html) {
            deadHandles.push(handle);
            return;
          }

          try {
            const template = document.createElement('template');
            template.innerHTML = html.trim();

            template.content.querySelectorAll('link[rel="stylesheet"]').forEach((link) => {
              const href = link.getAttribute('href');
              if (href && !document.querySelector(`link[href="${href}"]`)) {
                document.head.appendChild(link.cloneNode(true));
              }
            });

            const cardContent = template.content.querySelector('.card-wrapper');
            if (!cardContent) {
              deadHandles.push(handle);
              return;
            }

            const li = document.createElement('li');
            li.className = 'grid__item wishlist-page__item';

            const removeButton = document.createElement('button');
            removeButton.type = 'button';
            removeButton.className = 'wishlist-page__remove';
            removeButton.setAttribute('aria-label', 'Remove from wishlist');
            removeButton.textContent = 'Remove';
            removeButton.addEventListener('click', () => {
              this.removeFromWishlist(handle);
              li.remove();
              if (this.grid.children.length === 0) {
                this.showEmptyState();
              }
            });

            li.appendChild(cardContent);
            li.appendChild(removeButton);
            this.grid.appendChild(li);
          } catch (error) {
            // A single malformed entry shouldn't take down the whole list
            deadHandles.push(handle);
          }
        });

        if (deadHandles.length > 0) {
          const cleaned = this.getWishlist().filter((handle) => !deadHandles.includes(handle));
          this.setWishlist(cleaned);
        }

        if (this.grid.children.length === 0) {
          this.showEmptyState();
        }
      })
      .catch(() => {
        // Guarantee the page never ends up blank, even on an unexpected error
        this.showEmptyState();
      });
  }
}

customElements.define('wishlist-page', WishlistPage);
